import { StoreConst } from '@/store/constants'

export default {
  resetApiError(context: any) {
    context.commit(StoreConst.StoreHelper.SetApiErrorMutationName, '', { root: true })
  },
}
